// Routes that never get analytics of any kind (no banner, no tag, no tags/
// identify, no GA4 search): the external approval and proof pages carry
// the keys that authorise the customer's approval in the URL (?code=,
// ?keys=, ?token=, /order/entry/:entryKey) and Clarity/GA4 store the full
// URL. The same two prefixes are checked by the bootstrap script in
// public/index.html (source-text test pins them).
export const NO_ANALYTICS_ROUTE_PREFIXES = ["/public", "/approval"] as const;

export function isNoAnalyticsRoute(pathname: string): boolean {
  return NO_ANALYTICS_ROUTE_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix),
  );
}
